import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busBangKiemTuanThuApi } from "../../../api/bus/busBangKiemTuanThuApi";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eBusBangKiemTuanThuActionTypeIds,
	IBusBangKiemTuanThuDeleteStart,
	IBusBangKiemTuanThuLoadStart,
	IBusBangKiemTuanThuSaveStart
} from "../../action-types/bus/IBusBangKiemTuanThuActionTypes";
import { busBangKiemTuanThuActions } from "../../actions/bus/busBangKiemTuanThuActions";

export function* busBangKiemTuanThuSaga(): any {
	yield takeLatest(eBusBangKiemTuanThuActionTypeIds.LOAD_START, loadBusBangKiemTuanThuWorker)
	yield takeEvery(eBusBangKiemTuanThuActionTypeIds.DELETE_START, deleteBusBangKiemTuanThuWorker)
	yield takeEvery(eBusBangKiemTuanThuActionTypeIds.SAVE_START, saveBusBangKiemTuanThuWorker)
}
function* loadBusBangKiemTuanThuWorker(action: IBusBangKiemTuanThuLoadStart): any {
	const res: IBaseResponeModel = yield call([busBangKiemTuanThuApi, busBangKiemTuanThuApi.SelectByCoSo], action.payload)
	if (res.is_success) {
		yield put(busBangKiemTuanThuActions.loadBusBangKiemTuanThuSuccess(res.data || []))
	} else {
		yield put(busBangKiemTuanThuActions.loadBusBangKiemTuanThuError(res.message || "Không tải được bảng kiểm tuân thủ"))
	}
}
function* deleteBusBangKiemTuanThuWorker(action: IBusBangKiemTuanThuDeleteStart): any {
	const res: IBaseResponeModel = yield call([busBangKiemTuanThuApi, busBangKiemTuanThuApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busBangKiemTuanThuActions.deleteBusBangKiemTuanThuSuccess())
	} else {
		yield put(busBangKiemTuanThuActions.deleteBusBangKiemTuanThuErr(res.message || "Không xoá được bảng kiểm tuân thủ"))
	}
}
function* saveBusBangKiemTuanThuWorker(action: IBusBangKiemTuanThuSaveStart): any {
	let res: IBaseResponeModel;
	if (action.payload.id > 0) {
		res = yield call([busBangKiemTuanThuApi, busBangKiemTuanThuApi.Update], action.payload);
	} else {
		res = yield call([busBangKiemTuanThuApi, busBangKiemTuanThuApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busBangKiemTuanThuActions.saveBusBangKiemTuanThuSuccess())
	} else {
		yield put(busBangKiemTuanThuActions.saveBusBangKiemTuanThuError(res.message || "Không lưu được bảng kiểm tuân thủ"))
	}
}
